export default "__VITE_ASSET__b12bec02__"